export default __webpack_public_path__ + "static/media/Spinebreaker.db501dd9.jpg";